"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var multi_signature_auth_descriptor_1 = require("./multi-signature-auth-descriptor");
exports.MultiSignatureAuthDescriptor = multi_signature_auth_descriptor_1.default;
var single_signature_auth_descriptor_1 = require("./single-signature-auth-descriptor");
exports.SingleSignatureAuthDescriptor = single_signature_auth_descriptor_1.default;
//# sourceMappingURL=index.js.map